import { render, staticRenderFns } from "./customer-detail.vue?vue&type=template&id=78d7f868&scoped=true&"
import script from "./customer-detail.vue?vue&type=script&lang=js&"
export * from "./customer-detail.vue?vue&type=script&lang=js&"
import style0 from "./customer-detail.vue?vue&type=style&index=0&id=78d7f868&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7f868",
  null
  
)

export default component.exports